export function isEmpty(subject: any): boolean {
    if (typeof subject === 'undefined') {
        return true
    }
    if (subject === null) {
        return true
    }
}
